import { render, staticRenderFns } from "./ZhuanRang.vue?vue&type=template&id=7bf7d074"
import script from "./ZhuanRang.vue?vue&type=script&lang=js"
export * from "./ZhuanRang.vue?vue&type=script&lang=js"
import style0 from "./ZhuanRang.vue?vue&type=style&index=0&id=7bf7d074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports